import { getAdminPersonaScopes } from '../constants/roleAccess';

export const DISCOVER_FILTERS = [
  { value: 'journey', label: 'Stage (Journey)' },
  { value: 'role', label: 'Role' },
  { value: 'tag', label: 'Tag' },
  { value: 'capability', label: 'Capability' },
  { value: 'persona', label: 'Persona' },
];

const normalize = (value) => String(value || '').trim().toLowerCase();

export const getVisibleDiscoverFilters = (
  userDepartment,
  departments = [],
  personas = [],
  userRole = 'user',
  accessPersona = null,
  profileTeam = null,
  teams = [],
  accessPersonas = []
) => {
  const allowed = new Set(DISCOVER_FILTERS.map(({ value }) => value));
  const configuredFilters = (persona) =>
    Array.isArray(persona?.discoverFilters)
      ? persona.discoverFilters.filter((facet) => allowed.has(facet))
      : [];

  if (normalize(userRole) === 'admin') {
    return [...allowed];
  }

  const adminPersonaScopes = getAdminPersonaScopes(
    userRole,
    accessPersonas,
    accessPersona
  );
  if (adminPersonaScopes.length) {
    const normalizedScopes = adminPersonaScopes.map(normalize);
    const scopedPersonas = personas.filter(
      (option) =>
        normalizedScopes.includes(normalize(option?.value)) ||
        normalizedScopes.includes(normalize(option?.label))
    );
    return [...new Set(scopedPersonas.flatMap(configuredFilters))];
  }

  // The self-selected team may personalize which filters are shown, but it must
  // never be used as a tool-access or admin-access scope.
  const normalizedProfileTeam = normalize(profileTeam);
  if (normalizedProfileTeam) {
    const mappedTeam = teams.find(
      (option) =>
        normalize(option?.value) === normalizedProfileTeam ||
        normalize(option?.label) === normalizedProfileTeam
    );
    if (mappedTeam?.parentId) {
      const teamPersona = personas.find(
        (option) => String(option?.id) === String(mappedTeam.parentId)
      );
      if (teamPersona) return configuredFilters(teamPersona);
    }
  }

  // Unmapped teams retain the existing Workday department fallback.
  const normalizedDepartment = normalize(userDepartment);
  if (!normalizedDepartment) return [];

  const department = departments.find(
    (option) =>
      normalize(option?.value) === normalizedDepartment ||
      normalize(option?.label) === normalizedDepartment
  );
  if (!department?.parentId) return [];

  const persona = personas.find(
    (option) => String(option?.id) === String(department.parentId)
  );
  if (!persona) return [];

  return configuredFilters(persona);
};
